import VueRouter from "vue-router";
import Login from "../pages/Login";
import Parents from "../pages/parents/ParentsHome";

const router = new VueRouter({
  routes: [{
    path: "/parents",
    name: "Parents",
    component: Parents
  },
  {
    path: "/",
    redirect: "login",
    name: "Parents"
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/kids/new",
    name: "Add Child",
    component: () => import("../pages/parents/AddChild")
  },
  {
    path: "/kids",
    name: "Kids",
    component: () => import("../pages/kids/KidsHome")
  },
  {
    path: "/handlePatreon",
    name: "Patreon",
    component: () => import("../pages/settings/PatreonLink")
  },
  {
    path: "/kids/action/done",
    name: "Done",
    component: () => import("../pages/kids/Done")
  },
  {
    path: "/parents/chores/edit/:kid/:type/:choreId",
    name: "Edit Chore",
    component: () => import("../pages/parents/EditChore")
  },
  {
    path: "/rewards",
    name: "Rewards",
    component: () => import("../pages/parents/Rewards")
  },
  {
    path: "/settings/legal",
    name: "Legal",
    component: () => import("../pages/Legal")
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("./../pages/settings/SettingsHome")
  },

  {
    name: 'Support',
    path: "/settings/help",
    component: () => import("./../pages/settings/Help")
  },
  {
    path: "/settings/themes",
    name: "Themes",
    component: () => import("./../pages/settings/SettingsThemes")
  },
  {
    path: "/settings/payment/addcard",
    name: "Add Card",
    component: () => import("./../pages/settings/AddCard")
  },
  {
    path: "/settings/payment/removecard",
    name: "Settings | Remove Card",
    component: () => import("./../pages/settings/RemoveCard")
  },
  {
    path: "/settings/account",
    name: "Account Settings",
    component: () => import("./../pages/settings/SettingsAccount")
  },
  {
    path: "/settings/accessibility",
    name: "Accessibility Settings",
    component: () => import("./../pages/settings/SettingsAccessibility")
  },
  {
    path: "/logout",
    name: "Logging Out...",
    component: () => import("../pages/NoView/Logout")
  },
  {
    path: "/settings/account/changePin",
    name: "Logging Out...",
    component: () => import("../pages/NoView/ChangePin")
  },
  {
    path: "/wkth",
    name: "Walk",
    component: () => import("../pages/parents/Walkthru")
  }
  ]
});
const defaultTitle = "Chore Champion";
router.afterEach((to, from) => {
  gtag('event', 'route_change', {
    'screen_name': to.name
  });
  if (to.name === undefined) document.title = defaultTitle;
  else document.title = `${defaultTitle} | ${to.name}`;
  location.hash == "#/" ? null : history.pushState('/', 'Chore Champion', '/#/')
  setTimeout(() => location.hash == "#/" ? null : history.pushState('/', 'Chore Champion', '/#/'), 100)
});

export default router;
